import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import thunk from "redux-thunk";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import { CookiesProvider } from "react-cookie";
import rootReducer from "./store";
import "./index.css";
import App from "./App";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const store = createStore(rootReducer, applyMiddleware(thunk));
const root = ReactDOM.createRoot(document.getElementById("root"));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0, // disables retry globally
      refetchOnWindowFocus: false, //  prevent refetch on window focus
      // staleTime: 300000, // 5 minutes,(5 × 60 × 1000 = 300000 ms)
    },
    mutations: {
      retry: 0, // optional for mutations
    },
  },
});

root.render(
  <CookiesProvider>
    <Provider store={store}>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </BrowserRouter>
    </Provider>
  </CookiesProvider>
);
